module.exports = __webpack_public_path__ + "img/low2.05745536.png";